module.exports = __webpack_public_path__ + "images/emoji/gift.91d2caa849cc6fa04b08.png";